/**
 * <p>****************************************************************************</p >
 * <p><b>Copyright  2013-2019/6/12 soho team All Rights Reserved<b></p >
 * <ul style="margin:15px;">
 * <li>Description : 课程</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019/6/12</li>
 * <li>@author     : 唐胜</li>
 * </ul>
 * <p>****************************************************************************</p >
 */

import request from '../kernel/request'

export default {
	list(params) {
		return request.get('course', params)
	},
	listClass(params) {
		return request.get('course/list/class', params)
	},
	page(params) {
		return request.get('course/page', params)
	},
	save(data) {
		return request.post(`course`, data)
	},
	update(data) {
		return request.put(`course`, data)
	},
	delete(id) {
		return request.delete('course/' + id)
	},
	loadAll(id) {
		return request.get('course/load/' + id)
	},
	load(id) {
		return request.get('course/' + id)
	},
	edit(id) {
		return request.get('course/edit/' + id)
	},
	schedule: {
		list(params) {
			return request.get('schedule', params)
		},
		save(data) {
			return request.post(`schedule`, data)
		},
		update(data) {
			return request.put(`schedule`, data)
		},
		vid(data) {
			return request.put(`schedule/vid`, data)
		},
		delete(id) {
			return request.delete('schedule/' + id)
		},
		unloading(params) {
			return request.get('unloading', params)
		},
		load(id) {
			return request.get('schedule/' + id)
		},
		weekList(params) {
			return request.get('schedule/weekList', params)
		},
		group(params) {
			return request.get('schedule/group', params)
		},
		times(params) {
			return request.get('schedule/times', params)
		},
		open(id) {
			return request.get('schedule/open/' + id)
		},
		viewLog(id) {
			return request.get('schedule/viewLog/' + id)
		},
		sunAccount(id) {
			return request.get('schedule/sunAccount/' + id)
		},
		finish(id) {
			return request.get('schedule/finish/' + id)
		},
		uploadPhoto: `${request.baseURL}/schedule/uploadPhoto`,
	},
	view: {
		list(params) {
			return request.get('view/record', params)
		},
		page(params) {
			return request.get('view/record/page', params)
		},
	},
	attendance: {
		list(params) {
			return request.get('attendance', params)
		},
		save(data) {
			return request.post(`attendance`, data)
		},
		update(data) {
			return request.put(`attendance`, data)
		},
		delete(id) {
			return request.delete('attendance' + id)
		},
		load(id) {
			return request.get('attendance' + id)
		},
		import(params){
			return request.upload(`/attendance/import`, params)
		},
		groupBySchedule(params) {
			return request.get('attendance/groupBySchedule', params)
		},
		getByStudent(params) {
			return request.get('attendance/getByStudent', params)
		},
		getStudentOpenSchedule(params) {
			return request.get('attendance/getStudentOpenSchedule', params)
		},
		getAttendanceDetail(params) {
			return request.get('attendance/getAttendanceDetail', params)
		},
		getStudentScheduleAndPaper(params) {
			return request.get('attendance/getStudentScheduleAndPaper', params)
		}
	}
}
